/* ⚛ REACT */
import ReactDOM from "react-dom/client";

/* 📦 LIBS */
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { ToastContainer } from "react-toastify";

/* 🧠 REDUX */
import { store } from "./Redux/Store";

/* ⚙ CONFIG*/
import i18n from "./Config/i18n";

/* 🧭 ROUTES */
import Routes from "./Routes";

/* 📊 WEB VITALS */
import reportWebVitals from "./reportWebVitals";

/* 🎨 STYLES */
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  
  <I18nextProvider i18n={i18n}>
      <Provider store={store}>
      <ToastContainer style={{zIndex: '999999'}} />
        <BrowserRouter>
          <Routes/>
        </BrowserRouter>
      </Provider>
  </I18nextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
